import React, { Component } from 'react';
import classes from "./Conclusion.module.css";

export default class Conclusion extends Component {

    render() {
        // const { data, labels } = this.state;
        return (
            <div className={classes.container}>               
                <p className="text-anal">Some conclusions can be made from the numbers in these graphs. The creators of Animal Crossing seem to believe that Normal and Lazy personality types are appealing. This may be based on the fact that customers play the game to get away from stress in life so they want to be lazy, which is why they related to "Lazy" characters.</p>                
                <p className="text-anal">Likewise, Cats and Rabbits have the stereotype of being adorable, cute, and most importantly soft which is appealing to customers who want to escape from the hard and difficult times of this pandemic.</p>
                <p className="text-anal">More conlusions to come.</p> 
            </div>
        )
    }
}

/* Tutorial from:
     https://blog.bitsrc.io/customizing-chart-js-in-react-2199fa81530a
*/